export default __webpack_public_path__ + "static/media/panel8.71e0b9b6.jpg";